import { render } from "./AdminYellowNewUser.vue?vue&type=template&id=393c002a"
import script from "./AdminYellowNewUser.vue?vue&type=script&lang=js"
export * from "./AdminYellowNewUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__